import React from 'react';
import './MenuButton.css'

export type MenuButtonConfig = {
  label: string,
  onClick: () => void,
  description?: string,
  image?: string,
  textAlign?: string,
}

type Props = MenuButtonConfig & {
  className: string,
}

export const MenuButton = (props: Props): React.ReactElement => {
  const textAlign = props.textAlign === 'left' ? 'text-left' : (props.textAlign === 'right' ? 'text-right' : 'text-center')
  return (
    <div className={`menu-btn flex ${props.className}`} onClick={props.onClick}>
      {props.image && (
        <div className="flex align-center justify-center items-center min-w-24">
          <img src={`${process.env.APP_DATA_LINK + props.image}`} className="w-16 h-16" alt="" />
        </div>
      )}

      <div className={`flex ${textAlign} flex-1 align-center justify-center flex-col`}>
        <span className="text-2xl">{ props.label }</span>
        {props.description && (
          <span className="text-xs mt-2">{ props.description }</span>
        )}
      </div>
    </div>
  )
}
